enum USER_PERMISSIONS {
  SPECIAL_DEAL_EDIT = "SPECIAL_DEAL_EDIT",
  SPECIAL_PAYMENT_ALLOCATE = "SPECIAL_PAYMENT_ALLOCATE",
  SPECIAL_PAYMENT_EDIT = "SPECIAL_PAYMENT_EDIT",
  SPECIAL_SETTLEMENT_ACCOUNT_EDIT = "SPECIAL_SETTLEMENT_ACCOUNT_EDIT",
  DICTIONARY_COUNTRY_VIEW = "DICTIONARY_COUNTRY_VIEW",
  DICTIONARY_COUNTRY_EDIT = "DICTIONARY_COUNTRY_EDIT",
  DICTIONARY_LOCATION_VIEW = "DICTIONARY_LOCATION_VIEW",
  DICTIONARY_LOCATION_EDIT = "DICTIONARY_LOCATION_EDIT",
  DICTIONARY_COEFFICIENT_VIEW = "DICTIONARY_COEFFICIENT_VIEW",
  DICTIONARY_COEFFICIENT_EDIT = "DICTIONARY_COEFFICIENT_EDIT",
  DICTIONARY_CURRENCY_VIEW = "DICTIONARY_CURRENCY_VIEW",
  DICTIONARY_USER_EXTERNAL_VIEW = "DICTIONARY_USER_EXTERNAL_VIEW",
  DICTIONARY_USER_EXTERNAL_EDIT = "DICTIONARY_USER_EXTERNAL_EDIT",
  DICTIONARY_USER_EXTERNAL_MANAGE_DOCUMENTS = "DICTIONARY_USER_EXTERNAL_MANAGE_DOCUMENTS",
  DICTIONARY_USER_INTERNAL_VIEW = "DICTIONARY_USER_INTERNAL_VIEW",
  DICTIONARY_USER_INTERNAL_EDIT = "DICTIONARY_USER_INTERNAL_EDIT",
  DICTIONARY_ROTE_VIEW = "DICTIONARY_ROTE_VIEW",
  DICTIONARY_ROTE_EDIT = "DICTIONARY_ROTE_EDIT",
  DICTIONARY_ORDER_ASSIGN = "DICTIONARY_ORDER_ASSIGN",
  DICTIONARY_ORDER_VIEW = "DICTIONARY_ORDER_VIEW",
  DICTIONARY_ORDER_EDIT = "DICTIONARY_ORDER_EDIT",
  AUDIT_LOG_VIEW = "AUDIT_LOG_VIEW",
  DICTIONARY_COMPANY_VIEW = "DICTIONARY_COMPANY_VIEW",
  DICTIONARY_COMPANY_EDIT = "DICTIONARY_COMPANY_EDIT",
  DICTIONARY_ROTE_MARK_FOR_DELETION = "DICTIONARY_ROTE_MARK_FOR_DELETION",
  DICTIONARY_ROTE_CONTROL_UPDATING_RATES = "DICTIONARY_ROTE_CONTROL_UPDATING_RATES",
  DICTIONARY_ROTE_UPDATING_RATES = "DICTIONARY_ROTE_UPDATING_RATES",
  DEAL_PAYMENT_CALENDAR_VIEW = "DEAL_PAYMENT_CALENDAR_VIEW",
  LOCATION_MODERATION = "LOCATION_MODERATION",
  SUP_PAYMENT_REQUEST_VIEW_ALL = "SUP_PAYMENT_REQUEST_VIEW_ALL",
  SUP_PAYMENT_REQUEST_EDIT = "SUP_PAYMENT_REQUEST_EDIT",
  INTEGRATION_ERROR_TELEGRAM_NOTIFICATION = "INTEGRATION_ERROR_TELEGRAM_NOTIFICATION",
  RATE_USAGE_ANALYTICS_VIEW = "RATE_USAGE_ANALYTICS_VIEW",
  DEAL_EDIT_APPROVAL = "DEAL_EDIT_APPROVAL",
  OPERDAY_ERRORS_VIEW = "OPERDAY_ERRORS_VIEW",
}

export default USER_PERMISSIONS;
